module.exports = __webpack_public_path__ + "img/PlaceHolderLandscape.d3dce2c0.png";